export const albumsOfTheYear = [
  {
    year: 2025,
    winner: {
      artist: "Turnstile",
      title: "Never Enough",
      artwork: "/img/albums/2025-turnstile-never-enough.jpg"
    },
    runnerUp: {
      artist: "Architects",
      title: "The Sky, The Earth and All Between",
      artwork: "/img/albums/2025-architects-the-sky-the-earth-and-all-between.jpg"
    }
  },
  {
    year: 2024,
    winner: {
      artist: "Fontaines DC",
      title: "Romance",
      artwork: "/img/albums/2024-fontaines-dc-romance.jpg"
    },
    runnerUp: {
      artist: "Interlaker",
      title: "Interlaker",
      artwork: "/img/albums/2024-interlaker-interlaker.jpg"
    }
  },
  {
    year: 2023,
    winner: {
      artist: "Sleep Token",
      title: "Take Me Back To Eden",
      artwork: "/img/albums/2023-sleep-token-take-me-back-to-eden.jpg"
    },
    runnerUp: {
      artist: "Enter Shikari",
      title: "A Kiss For The Whole World",
      artwork: "/img/albums/2023-enter-shikari-a-kiss-for-the-whole-world.jpg"
    }
  },
  {
    year: 2022,
    winner: {
      artist: "Fontaines DC",
      title: "Skinty Fia",
      artwork: "/img/albums/2022-fontaines-dc-skinty-fia.jpg"
    },
    runnerUp: {
      artist: "Sweet Pill",
      title: "Where The Heart Is",
      artwork: "/img/albums/2022-sweet-pill-where-the-heart-is.jpg"
    }
  },
  {
    year: 2021,
    winner: {
      artist: "Gojira",
      title: "Fortitude",
      artwork: "/img/albums/2021-gojira-fortitude.jpg"
    },
    runnerUp: {
      artist: "New Pagans",
      title: "The Seed, The Vessel, The Roots and All",
      artwork: "/img/albums/2021-new-pagans-the-seed-the-vessel-the-roots-and-all.jpg"
    }
  },
  {
    year: 2020,
    winner: {
      artist: "Phoxjaw",
      title: "Royal Swan",
      artwork: "/img/albums/2020-phoxjaw-royal-swan.jpg"
    },
    runnerUp: {
      artist: "God Damn",
      title: "God Damn",
      artwork: "/img/albums/2020-god-damn-god-damn.jpg"
    }
  },
  {
    year: 2019,
    winner: {
      artist: "Tool",
      title: "Fear Inoculum",
      artwork: "/img/albums/2019-tool-fear-inoculum.jpg"
    },
    runnerUp: {
      artist: "PUP",
      title: "Morbid Stuff",
      artwork: "/img/albums/2019-pup-morbid-stuff.jpg"
    }
  },
  {
    year: 2018,
    winner: {
      artist: "Delta Sleep",
      title: "Ghost City",
      artwork: "/img/albums/2018-delta-sleep-ghost-city.jpg"
    },
    runnerUp: {
      artist: "Estrons",
      title: "You Say I'm Too Much, I Say You're Not Enough",
      artwork: "/img/albums/2018-estrons-you-say-im-too-much-i-say-youre-not-enough.jpg"
    }
  },
  {
    year: 2017,
    winner: {
      artist: "Jamie Lenman",
      title: "Devolver",
      artwork: "/img/albums/2017-jamie-lenman-devolver.jpg"
    },
    runnerUp: {
      artist: "Idles",
      title: "Brutalism",
      artwork: "/img/albums/2017-idles-brutalism.jpg"
    }
  },
  {
    year: 2016,
    winner: {
      artist: "Radiohead",
      title: "A Moon Shaped Pool",
      artwork: "/img/albums/2016-radiohead-a-moon-shaped-pool.jpg"
    },
    runnerUp: {
      artist: "Mylets",
      title: "Arizona",
      artwork: "/img/albums/2016-mylets-arizona.jpg"
    }
  },
  {
    year: 2015,
    winner: {
      artist: "Wolf Alice",
      title: "My Love Is Cool",
      artwork: "/img/albums/2015-wolf-alice-my-love-is-cool.jpg"
    },
    runnerUp: {
      artist: "Gaz Coombes",
      title: "Matador",
      artwork: "/img/albums/2015-gaz-coombes-matador.jpg"
    }
  },
  {
    year: 2014,
    winner: {
      artist: "Royal Blood",
      title: "Royal Blood",
      artwork: "/img/albums/2014-royal-blood-royal-blood.jpg"
    },
    runnerUp: {
      artist: "Eagulls",
      title: "Eagulls",
      artwork: "/img/albums/2014-eagulls-eagulls.jpg"
    }
  },
  {
    year: 2013,
    winner: {
      artist: "Arctic Monkeys",
      title: "AM",
      artwork: "/img/albums/2013-arctic-monkeys-am.jpg"
    },
    runnerUp: {
      artist: "Bring Me The Horizon",
      title: "Sempiternal",
      artwork: "/img/albums/2013-bring-me-the-horizon-sempiternal.jpg"
    }
  },
  {
    year: 2012,
    winner: {
      artist: "Bloc Party",
      title: "Four",
      artwork: "/img/albums/2012-bloc-party-four.jpg"
    },
    runnerUp: {
      artist: "Deftones",
      title: "Koi no Yokan",
      artwork: "/img/albums/2012-deftones-koi-no-yokan.jpg"
    }
  },
  {
    year: 2011,
    winner: {
      artist: "Foo Fighters",
      title: "Wasting Light",
      artwork: "/img/albums/2011-foo-fighters-wasting-light.jpg"
    },
    runnerUp: {
      artist: "The Kills",
      title: "Blood Pressures",
      artwork: "/img/albums/2011-the-kills-blood-pressures.jpg"
    }
  },
  {
    year: 2010,
    winner: {
      artist: "Foals",
      title: "Total Life Forever",
      artwork: "/img/albums/2010-foals-total-life-forever.jpg"
    },
    runnerUp: {
      artist: "Dead Weather",
      title: "Sea of Cowards",
      artwork: "/img/albums/2010-dead-weather-sea-of-cowards.jpg"
    }
  }
];
